<h1 matDialogTitle>TFG Rewards Account</h1>

<mat-dialog-content>
  <form *ngIf="!alreadyLinked" class="dynamic-form" [formGroup]="form" style="width: 100%">
    <div
      fxLayout="row wrap"
      fxLayoutAlign="start start"
      fxFlexFill
      fxLayoutGap="16px grid"
    >
      <mat-form-field fxFlex="30" width="100%">
        <mat-label>Store</mat-label>
        <mat-select formControlName="storeId">
          <mat-option *ngFor="let store of stores" [value]="store.storeId">
            {{ store.storeName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field fxFlex="20" width="100%">
        <mat-label>Identifier Type</mat-label>
        <mat-select
          formControlName="identifierType"
          (selectionChange)="identifierTypeChanged($event)"
        >
          <mat-option
            *ngFor="let type of identifierTypes"
            [value]="type.identifierTypeCode"
          >
            {{ type.identifierTypeDisplay }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!--
'TFG-LOYALTY-CARD','TFG-CREDIT-CARD','RSA-ID','PASSPORT','CELL-PHONE'
-->
      <ng-container [ngSwitch]="form.value.identifierType">
        <ng-container *ngSwitchCase="'TFG-LOYALTY-CARD'">
          <mat-form-field fxFlex="30" width="100%">
            <mat-label>TFG Loyalty card number</mat-label>
            <input
              matInput
              style="text-align: left"
              type="text"
              min="19"
              max="19"
              formControlName="identifierValue"
              autocomplete="new-password"
              (keyup.enter)="checkForTfgCardScan($event, $event.target.value)"
            />
          </mat-form-field>
        </ng-container>
        <ng-container *ngSwitchCase="'TFG-CREDIT-CARD'">
          <mat-form-field fxFlex="30" width="100%">
            <mat-label>TFG Credit Card Number</mat-label>
            <input
              matInput
              style="text-align: left"
              type="text"
              min="19"
              max="19"
              formControlName="identifierValue"
              autocomplete="new-password"
              (keyup.enter)="checkForTfgCardScan($event, $event.target.value)"
            />
          </mat-form-field>
        </ng-container>
        <ng-container *ngSwitchCase="'RSA-ID'">
          <mat-form-field fxFlex="30" width="100%">
            <mat-label>RSA Id Number</mat-label>
            <input
              matInput
              #rsaid
              maxlength="13"
              formControlName="identifierValue"
            />
            <mat-hint align="end">{{ rsaid.value.length }} / 13</mat-hint>
          </mat-form-field>
        </ng-container>
        <ng-container *ngSwitchCase="'PASSPORT'">
          <mat-form-field fxFlex="30" width="100%">
            <mat-label>Passport Number</mat-label>
            <input
              matInput
              #passport
              maxlength="16"
              formControlName="identifierValue"
            />
            <mat-hint align="end">{{ passport.value.length }} / 16</mat-hint>
          </mat-form-field>
        </ng-container>
        <ng-container *ngSwitchCase="'CELL-PHONE'">
          <mat-form-field fxFlex="30" width="100%">
            <mat-label>Cell Phone Number</mat-label>
            <input
              matInput
              #cellphone
              maxlength="10"
              type="text"
              formControlName="identifierValue"
            />
            <mat-hint align="end">{{ cellphone.value.length }} / 10</mat-hint>
            <mat-hint align="start">Numbers only, ex: 0731234567</mat-hint>
          </mat-form-field>
        </ng-container>
      </ng-container>

      <div fxFlex="10" width="100%">
        <button
          mat-raised-button
          color="primary"
          [disabled]="!form.valid || tfgRewardsDetails"
          (click)="validate()"
        >
          Search
        </button>
      </div>

      <div fxFlex="10" width="100%">
        <button
          mat-raised-button
          color="primary"
          [disabled]="!tfgRewardsDetails && !rewardsError"
          (click)="reset()"
        >
          Reset
        </button>
      </div>
    </div>
  </form>

  <mat-card class="account-message" *ngIf="rewardsError" style="margin-top: 16px;">
    <mat-card-content>
      <p>{{rewardsError}}</p>
    </mat-card-content>
  </mat-card>

  <div *ngIf="tfgRewardsDetails"
  style="
    display: flex;
    flex-direction: row;
    align-content: stretch;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 16px;
    margin-top: 16px;
  "
>
  <div style="width: 100%;display: flex">
    <mat-card style="width: 100%;">
      <mat-card-header>
        <mat-card-subtitle>Customer Details</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <table style="width: 100%;">
          <tr>
            <th class="th-label" style="min-width: 90px;">Last Name</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.Person?.LastName}}</td>
          </tr>
          <tr>
            <th class="th-label" style="min-width: 90px;">First Name</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.Person?.Name}}</td>
          </tr>
          <tr>
            <th class="th-label" style="min-width: 90px;">Date of Birth</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.Person?.DateOfBirth | date:'longDate'}}</td>
          </tr>
          <tr>
            <th class="th-label" style="min-width: 90px;">Country</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.Person?.Country?.Name}}</td>
          </tr>
          <tr>
            <th class="th-label" style="min-width: 90px;">Phone Number</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.ContactNumber && tfgRewardsDetails?.Customer?.ContactNumber.length > 0 ? tfgRewardsDetails?.Customer.ContactNumber[0].Number : ''}}</td>
          </tr>
          <tr>
            <th class="th-label" style="min-width: 90px;">Identification Type</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.Person?.IdentificationType?.Name}}</td>
          </tr>
          <tr>
            <th class="th-label" style="min-width: 90px;">Identification Value</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.Person?.IdentificationValue}}</td>
          </tr>
          <tr>
            <th class="th-label" style="min-width: 90px;">Identification Verified</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.IsIdVerified ? 'Yes' : 'No'}}</td>
          </tr>
        </table>
      </mat-card-content>
    </mat-card>
  </div>
  <div
    style="
      width: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 16px;
    "
  >
    <mat-card>
      <mat-card-header>
        <mat-card-subtitle>Loyalty</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <table style="width: 100%;" *ngIf="tfgRewardsDetails?.Customer?.Loyalty && tfgRewardsDetails?.Customer?.Loyalty.length > 0">
          <tr>
            <th class="th-label" style="min-width: 90px;">Account Status</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.Loyalty[0].AccountStatus}}</td>
          </tr>
          <tr>
            <th class="th-label" style="min-width: 90px;">Savings</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.Loyalty[0].SavingsToDate | number:'1.2-2'}}</td>
          </tr>
          <tr>
            <th class="th-label" style="min-width: 90px;">Card Name</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.Loyalty[0].Card && tfgRewardsDetails?.Customer?.Loyalty[0].Card.length > 0 ? tfgRewardsDetails?.Customer?.Loyalty[0].Card[0].Name : ''}}</td>
          </tr>
          <tr>
            <th class="th-label" style="min-width: 90px;">Card Number</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.Loyalty[0].Card && tfgRewardsDetails?.Customer?.Loyalty[0].Card.length > 0 ? tfgRewardsDetails?.Customer?.Loyalty[0].Card[0].Code : ''}}</td>
          </tr>
        </table>
      </mat-card-content>
    </mat-card>
    <mat-card>
      <mat-card-header>
        <mat-card-subtitle>Options</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <table style="width: 100%;" *ngIf="tfgRewardsDetails?.Customer?.Option">
          <tr>
            <th class="th-label" style="min-width: 90px;">3rd Party Marketing Allowed</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.Option?.IsThirdPartyMarketingAllowed ? 'Yes' : 'No'}}</td>
          </tr>
          <tr>
            <th class="th-label" style="min-width: 90px;">Marketing Allowed</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.Option?.IsMarketingAllowed ? 'Yes' : 'No'}}</td>
          </tr>
          <tr>
            <th class="th-label" style="min-width: 90px;">Customer Blocked</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.Option?.IsCustomerBlocked ? 'Yes' : 'No'}}</td>
          </tr>
          <tr>
            <th class="th-label" style="min-width: 90px;">Registered for Loyalty</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.Option?.IsRegisteredForLoyalty ? 'Yes' : 'No'}}</td>
          </tr>
          <tr>
            <th class="th-label" style="min-width: 90px;">School Days Allowed</th>
            <td class="td-value">{{tfgRewardsDetails?.Customer?.Option?.IsSchoolDaysAllowed ? 'Yes' : 'No'}}</td>
          </tr>
        </table>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="tfgRewardsDetails" style="width: 100%; margin-top: 16px;">
  <mat-card>
      <mat-card-header>
          <mat-card-subtitle>Promotions</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <kendo-grid [kendoGridBinding]="tfgRewardsDetails?.Promotions" [scrollable]="true" [resizable]="true" [reorderable]="true"
        [sortable]="true">

        <kendo-grid-column [width]="180" field="Name" title="Name">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="ellipse">
              {{dataItem.Name}}
            </span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="100" field="DateStart" title="Start Date">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="ellipse">
              {{dataItem.DateStart | date:'longDate'}}
            </span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="100" field="DateEnd" title="End Date">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="ellipse">
              {{dataItem.DateEnd | date:'longDate'}}
            </span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="80" field="NumberOfSets" title="Number of Sets">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="ellipse">
              {{dataItem.NumberOfSets}}
            </span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="80" field="QuantityToPurchase" title="Qty to Purchase">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="ellipse">
              {{dataItem.QuantityToPurchase}}
            </span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="80" field="ValueOffPurchase" title="Value off Purchase">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="ellipse">
              {{dataItem.ValueOffPurchase}}
            </span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="80" field="IsBirthday" title="Birthday">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.IsBirthday ? 'Yes' : 'No'}}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="80" field="IsMarkdown" title="Markdown">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.IsMarkdown ? 'Yes' : 'No'}}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="80" field="IsProductPromotion" title="Product Promo">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.IsProductPromotion ? 'Yes' : 'No'}}
          </ng-template>
        </kendo-grid-column>

        <!-- <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="showEmailDetails">
          <div style="margin: 16px;">
            <kendo-grid [kendoGridBinding]="dataItem.emails" [scrollable]="true" [resizable]="true" [reorderable]="true"
              [sortable]="true">

              <kendo-grid-column [width]="150" field="emailType" title="Email. Type"> </kendo-grid-column>
              <kendo-grid-column [width]="200" field="sentAt" title="Sent At">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.sentAt | date: 'MMM d, yyyy HH:mm'}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [width]="250" field="sentTo" title="Sent To"> </kendo-grid-column>
              <kendo-grid-column [width]="200" field="emailStatus" title="Email Status"> </kendo-grid-column>

            </kendo-grid>
          </div>
        </ng-template> -->
      </kendo-grid>
      </mat-card-content>
  </mat-card>
</div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button matDialogClose>Close</button>
    <button *ngIf="!alreadyLinked" mat-button [disabled]="!tfgRewardsDetails" (click)="linkRewards()">Link Rewards Account</button>

</mat-dialog-actions>
